export const experiencias = [
  {
    titulo: "Desenvolvimento de APIs Estruturadas",
    descricao: "Criação de APIs RESTful com arquitetura em camadas, padrões de projeto e boas práticas de desenvolvimento. Foco em separação de responsabilidades, injeção de dependência e testes unitários.",
  },
  {
    titulo: "Integração com Sistemas Externos",
    descricao: "Experiência prática em integrar APIs externas utilizando o padrão Facade, gerenciamento de autenticação e tratamento de erros em comunicações HTTP.",
  },
  {
    titulo: "Validações Complexas",
    descricao: "Implementação de regras de negócio complexas com validações robustas, tratamento de exceções centralizado e feedback claro ao consumidor da API.",
  },
  {
    titulo: "Arquitetura Limpa de Projetos",
    descricao: "Organização de projetos com separação clara entre camadas, código limpo, nomenclatura consistente e documentação técnica adequada.",
  },
  {
    titulo: "Mensageria e Processamento Assíncrono",
    descricao: "Experiência com mensageria para processamento assíncrono de eventos, desacoplamento entre serviços e melhoria de performance. Implementação de fluxos baseados em filas, controle de retries e tratamento de falhas.",
  },
  {
    titulo: "Autenticação e Autorização com JWT",
    descricao: "Implementação de autenticação baseada em JSON Web Token (JWT), controle de acesso por perfil, geração e validação de tokens, proteção de rotas e gerenciamento seguro de sessões em aplicações web.",
  },
];